import React from 'react'
import { ProgressPropsType } from './types'

// Styles
import './styles.scss'

export default ({ title, percent, style }: ProgressPropsType) => {
  return (
    <div className={'progress'} style={style}>
      <div className={'progress__active'} style={{ width: percent + '%' }} />
      <span className={'progress__percent'}>
        {title}
        {percent}%
      </span>
    </div>
  )
}
